import type { UserPreferenceType } from '@atlassian/jira-dashboard-user-preference';
import type { ReactGadgetGetInitialState } from '@atlassian/jira-react-gadgets-common';
import type { HeatmapGadgetData } from '../types';

const getInitialState: ReactGadgetGetInitialState<HeatmapGadgetData, UserPreferenceType[]> = () =>
	Promise.resolve({});

export default getInitialState;
